import React from 'react';
import { Headline } from '@ldp-web/component-library/ui/molecules/headline';
import { ParagraphSize, ParagraphStyle, TImage } from '@ldp-web/component-library/types';
import { useRedirectLink } from '../../utils';
import { useSDMRouterContext } from '@ldp/sdm-contexts';
import { WrapperComponent } from '../wrapper';
import {
  HeadingSize,
  HeadingTag,
  IHeaderGroupComponentProps,
  headlineVariants,
  paragraphVariants,
} from '@ldp/common-types';

export type HeadlineKey = keyof typeof headlineVariants;
export type ParagraphKey = keyof typeof paragraphVariants;

/** a customizable header component that takes in headline and paragraph properties */

export const HeaderGroupComponent = ({
  headline,
  paragraph,
  callToAction,
  logoUrl,
  logoAltText,
  logoUrl2,
  logo2AltText,
  noWrapper,
  styling,
  id,
  desktopImage,
  tabletImage,
  mobileImage,
  ...rest
}: IHeaderGroupComponentProps & {
  noWrapper?: boolean;
  /** id of component */
  id?: string;
  tabletImage?: TImage;
  mobileImage?: TImage;
}) => {
  const { router } = useSDMRouterContext();
  const redirectToPage = useRedirectLink(router);
  const variantData = headlineVariants[headline?.variantId || 'LARGE_01'];
  const paragraphStyleData = paragraph ? paragraphVariants[paragraph?.variantId] : null;

  const headerGroupProps = {
    logoUrl: logoUrl,
    logoAltText: logoAltText,
    logoUrl2: logoUrl2,
    logo2AltText: logo2AltText,
    title: headline?.text,
    subTitle: paragraph?.text,
    paragraphStyle: paragraphStyleData?.style as ParagraphStyle,
    headingTag: headline?.headerType?.toLowerCase() as HeadingTag,
    headlineSize: variantData.headlineSize as HeadingSize,
    paragraphLeftIcon: paragraph?.subTitleLeftIcon,
    paragraphSize: paragraphStyleData?.size as ParagraphSize,
    link: headline?.callToAction,
    linkBottom: callToAction,
    alignment: headline?.alignment,
    clickHandler: redirectToPage,
    desktopImage,
    tabletImage,
    mobileImage,
    ...rest,
  };

  if (noWrapper) {
    return <Headline {...headerGroupProps} />;
  }
  return (
    <WrapperComponent styling={styling} id={id}>
      <Headline {...headerGroupProps} />
    </WrapperComponent>
  );
};
